import React from 'react';
import { Button, LoadingButton } from '@one-thd/sui-atomic-components';
export var FooterButtons = function (_a) {
    var type = _a.type, loading = _a.loading, disableContinue = _a.disableContinue, continueText = _a.continueText, continueHandler = _a.continueHandler, cancelHandler = _a.cancelHandler, testId = _a.testId;
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-1 lg:sui-grid-cols-5 sui-gap-2" },
        React.createElement("div", { className: "sui-col-span-2 lg:sui-order-2" },
            React.createElement(LoadingButton, { type: type, disabled: disableContinue, fullWidth: true, "data-testid": testId, loading: !!loading, onClick: function () {
                    if (continueHandler) {
                        continueHandler();
                    }
                } }, continueText)),
        React.createElement("div", { className: "sui-col-span-1 lg:sui-order-1" },
            React.createElement(Button, { fullWidth: true, variant: "secondary", onClick: cancelHandler }, "Cancel"))));
};
